import Tag from '@savvy-kit/patterns/tag';
import { isNil } from 'es-toolkit';

import type { TagCellContentProps } from '../../types/cell-types';

export function TagCellContent({ label, onRemove, type = 'read-only', ...props }: TagCellContentProps) {
  return (
    <Tag type={type} dismissible={!isNil(onRemove)} onDismiss={onRemove} {...props}>
      {label}
    </Tag>
  );
}
